/*
 * Copyright (c) 2022 Puratos. All rights reserved.
 */

import * as React from 'react';
import { FunctionComponent, PropsWithChildren, useEffect } from 'react';
import { selectMapping } from '../../../selectors/my-puratos/generics';
import { useSelector } from 'react-redux';
import { WithLoading } from '../hoc/withLoading';
import { isMappingLoaded } from '../../../api/utils/aemEndpointUtil';
import NotificationHub from '../molecules/alert/NotificationHub';
import { OrderBeforeMessage } from '../molecules/alert/OrderBeforeMessage';
import { isOrderBeforeMessageEnabled } from '../../../selectors/generic';
import { ALERTS } from '../../../data/my-puratos/AlertId';
import Alert from '../atoms/alert/Alert';
import { BootstrapVariation } from '../../../data/bootstrap/bootstrap.variation';
import { useI18N } from '../hoc/withI18N';
import { redirectToAccountPending } from '../../../utils/my-puratos/redirectAccountPending';

const style = { margin: 'auto' };

export const CartPage: FunctionComponent<PropsWithChildren> = ({ children }) => {
    const translate = useI18N();

    const mapping = useSelector(selectMapping);
    const orderBeforeMessageEnabled = useSelector(isOrderBeforeMessageEnabled);
    const basketChanges = JSON.parse(localStorage.getItem('basketChanges')) || [];

    useEffect(() => {
        redirectToAccountPending();
    }, []);

    const clearLocalStorage = () => {
        localStorage.removeItem('basketChanges');
    };

    return (
        <div>
            <WithLoading loading={!isMappingLoaded(mapping)} style={style}>
                <div className="cart p-padding-top-md p-bg-grey1">
                    <div className="container cart__messages">
                        <NotificationHub />

                        {orderBeforeMessageEnabled && (
                            <div className="row p-margin-none">
                                <OrderBeforeMessage key={'order-before'} />
                            </div>
                        )}

                        {basketChanges?.length > 0 && (
                            <Alert
                                type={BootstrapVariation.info}
                                key={ALERTS.cart.cartChanges}
                                onClose={clearLocalStorage}
                            >
                                <div
                                    dangerouslySetInnerHTML={{
                                        __html: translate('The cart was updated, please review your cart content:'),
                                    }}
                                />
                                <ul>
                                    {basketChanges.map(change => (
                                        <li key={`material-${change.materialNumber}`}>
                                            {change.materialNumber + ' - ' + change.productName}
                                            {change.productLink ? (
                                                <>
                                                    {' '}
                                                    -{' '}
                                                    <a href={change.productLink} target="_blank" rel="noreferrer">
                                                        {change.productLink}
                                                    </a>
                                                </>
                                            ) : (
                                                ''
                                            )}
                                        </li>
                                    ))}
                                </ul>
                            </Alert>
                        )}
                    </div>

                    {children}
                </div>
            </WithLoading>
        </div>
    );
};
